module.exports = __webpack_public_path__ + "img/ic-docs-center.f6951e0e.svg";